// extracted by mini-css-extract-plugin
export default {"toolbar":"style_toolbar__n4zNi","layout":"style_layout__l5KQm","grid":"style_grid__rJT5e","settings":"style_settings__9BJtP"};